import quickFetch from 'quick-fetch';
import * as ReviewTypes from 'ecosystem-marketplace-core/constants/reviews/ReviewType';
import { getApiClient } from './apiClient';
let apiBase = 'ecosystem/v1';
export const setEcosystemApiBase = _apiBase => {
  apiBase = _apiBase;
};

function getQuickFetch(requestName) {
  const earlyRequest = quickFetch.getRequestStateByName(requestName);
  if (!earlyRequest) return Promise.reject(new Error(`No early request found: ${requestName}`));
  return new Promise((resolve, reject) => {
    earlyRequest.whenFinished(result => {
      quickFetch.removeEarlyRequest(requestName);
      resolve(result);
    });
    earlyRequest.onError(() => {
      quickFetch.removeEarlyRequest(requestName);
      reject(new Error(`Early request failed: ${requestName}`));
    });
  });
}

export function searchThemes(queries) {
  return getApiClient().post(`${apiBase}/themes/search`, {
    data: queries
  });
}
export function getCollections() {
  return getQuickFetch('collections').catch(() => {
    return getApiClient().get(`${apiBase}/self-serve/themes/collections/published`);
  });
}
export function getCallouts() {
  return getQuickFetch('callouts').catch(() => {
    return getApiClient().get(`${apiBase}/self-serve/callouts/published?offeringType=THEME`);
  });
}
export function fetchCollectionOfferingIdsFromSelfServe(id) {
  return getApiClient().get(`${apiBase}/self-serve/themes/collections/${id}/items`, {
    query: {
      length: 200
    }
  }).then(({
    items
  }) => {
    return items.map(({
      offeringId
    }) => offeringId);
  });
}
export const getSearchTags = () => {
  return getApiClient().get(`${apiBase}/themes/search-tags`);
};
const providersEarlyRequestName = 'theme-providers';
export function getProviders(offeringType) {
  const earlyRequest = quickFetch.getRequestStateByName(providersEarlyRequestName);

  const fetchData = () => getApiClient().get(`${apiBase}/providers/names`, {
    query: {
      'offering-type': offeringType
    }
  });

  let resultPromise;

  if (earlyRequest) {
    resultPromise = new Promise((resolve, reject) => {
      earlyRequest.whenFinished(result => {
        resolve(result);
        quickFetch.removeEarlyRequest(providersEarlyRequestName);
      });
      earlyRequest.onError(() => {
        // retry
        fetchData().then(resolve, reject).catch();
        quickFetch.removeEarlyRequest(providersEarlyRequestName);
      });
    });
  } else {
    resultPromise = fetchData();
  }

  return resultPromise;
}
export const getUnusedFilters = () => {
  const earlyRequest = quickFetch.getRequestStateByName('unused-filters');

  const fetchData = () => getApiClient().get(`${apiBase}/themes/unused-filters`);

  let resultPromise;

  if (earlyRequest) {
    resultPromise = new Promise((resolve, reject) => {
      earlyRequest.whenFinished(result => {
        resolve(result);
        quickFetch.removeEarlyRequest('unused-filters');
      });
      earlyRequest.onError(() => {
        // retry
        fetchData().then(resolve, reject).catch();
        quickFetch.removeEarlyRequest('unused-filters');
      });
    });

    if (window.newrelic) {
      window.newrelic.setCustomAttribute('unused-filters-early-request-used', Boolean(earlyRequest.finished));
    }
  } else {
    resultPromise = fetchData();
  }

  return resultPromise;
};
export const fetchReviewability = offeringId => {
  return getApiClient().get(`${apiBase}/reviews/reviewability/offerings/${offeringId}`);
};
export const writeReview = review => {
  return getApiClient().post(`${apiBase}/reviews`, {
    data: review
  });
};
export const fetchReviews = queries => {
  return getApiClient().post(`${apiBase}/reviews/search`, {
    data: Object.assign({}, queries, {
      reviewType: ReviewTypes.THEME
    })
  });
};
export const fetchReviewStats = offeringId => getApiClient().post(`${apiBase}/reviews/stats`, {
  data: {
    offeringId,
    reviewType: ReviewTypes.THEME
  }
});
export const toggleHelpful = (reviewId, isHelpful) => {
  return getApiClient().put(`${apiBase}/reviews/${reviewId}/helpful`, {
    data: isHelpful
  });
};
export const reportReview = (reviewId, reason, comment) => getApiClient().post(`${apiBase}/reviews/${reviewId}/report`, {
  data: {
    reason,
    comment
  }
});
export const reportReply = (reviewId, replyId, reason, comment) => getApiClient().post(`${apiBase}/reviews/${reviewId}/replies/${replyId}/report`, {
  data: {
    reason,
    comment
  }
});
export const purchase = purchaseInfo => getApiClient().post(`${apiBase}/transactions/sales`, {
  data: purchaseInfo
});
export const getThemeDetails = slug => getApiClient().get(`${apiBase}/themes/details`, {
  query: {
    slug
  }
});
export const getThemeDetailsPreview = slug => getApiClient().get(`${apiBase}/themes/details/preview`, {
  query: {
    slug
  }
});
export const getAcademyCertifications = () => getApiClient().get(`${apiBase}/academy/certifications`);
export const getVersionHistory = ({
  offeringId,
  offset,
  limit
}) => getApiClient().get(`${apiBase}/offerings/versions/history`, {
  query: {
    offeringId,
    offset,
    limit
  }
});
export function getAssetInstallability(offeringId) {
  return getApiClient().get(`${apiBase}/assets/${offeringId}/installability`);
}
export function getCompatibility() {
  return getApiClient().get(`${apiBase}/compatibility/themes`);
}